import { render, staticRenderFns } from "./sair.vue?vue&type=template&id=709f516f&scoped=true"
import script from "./sair.vue?vue&type=script&lang=ts"
export * from "./sair.vue?vue&type=script&lang=ts"
import style0 from "./sair.vue?vue&type=style&index=0&id=709f516f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709f516f",
  null
  
)

export default component.exports